import * as React from "react";
import { observer } from "mobx-react-lite";
import { MARKETING_URL } from "../../../envVariables";
import { Theme } from "../../../mobxStores/uiData/theme";
import { CreateAccount } from "./createAccount";

interface Props {
  awsAccountId: string;
  providerId: string;
  customerIdentifier: string;
}
const RegistrationRaw: React.FC<Props> = ({ awsAccountId, providerId, customerIdentifier }) => {
  return (
    <div style={{ minWidth: 500, maxWidth: 800 }}>
      <div className="w-full flex justify-center mb-8">
        <a href={`${MARKETING_URL}`} target={"_blank"} rel={`noopener`} style={{ width: 300, height: 110 }}>
          <img
            className="controlplane-logo"
            height={"auto"}
            src={`/resources/logos/controlPlaneLogo${Theme.theme === "dark" ? "White" : ""}.svg`}
            alt="Control Plane Logo"
          />
        </a>
      </div>
      <div className="font-semibold text-lg mb-4">Create a Billing Account</div>
      <CreateAccount providerId={providerId} awsAccountId={awsAccountId} customerIdentifier={customerIdentifier} />
    </div>
  );
};

export const Registration = observer(RegistrationRaw);
